import { render, staticRenderFns } from "./BlockText.vue?vue&type=template&id=33677968&scoped=true&"
import script from "./BlockText.vue?vue&type=script&lang=js&"
export * from "./BlockText.vue?vue&type=script&lang=js&"
import style0 from "./BlockText.vue?vue&type=style&index=0&id=33677968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33677968",
  null
  
)

export default component.exports